// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bar_a"};